import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { changePassword, saveProfile } from "../../actions/profile";
import { editUserData, fakeLogin } from "../../actions/user";
import useApi from "../../hooks/useApi";
import usePermission from "../../hooks/usePermission";
import { applyToFormData, toFormData } from "../../utils";
import Preloader from "../Preloader";
import { standartErrorToast, standartInfoToast } from "../toasts";
import Form from "./Form";
import "./index.css";
import PersonalCabinet from "../../pages/PersonalCabinet";
import { useParams } from "react-router-dom";


const Profile = ({ history }) => {

  const dispatch = useDispatch();
  const { employeeId } = useParams()
  const canEditAgency = usePermission("general");
  const isNotAgent = usePermission("not-agent");

  const { data, isLoading: isProfileLoading, send } = useApi({
    payload: ["panpartner:profile.ajax", "getProfile", { employeeId }],
    successCallback: resp => {
      setSettings(resp.settings)
      setTgSettings(resp.tgSettings)
      setEmailSettings(resp.emailSettings)
      setPushSettings(resp.pushSettings)
    }
    })

  const [settings, setSettings] = useState()
  const [tgSettings, setTgSettings] = useState()
  const [emailSettings, setEmailSettings] = useState()
  const [pushSettings, setPushSettings] = useState()

  useEffect(() => {
    dispatch(fakeLogin())
  }, []);

  const [isUpdating, setIsUpdationg] = useState(false)
  const handleSave = values => {
    setIsUpdationg(true)
    const formData = toFormData(values, false, true, true)

    applyToFormData(formData, settings, "settings")

    if (tgSettings) {
      if (Array.isArray(tgSettings)) {
        tgSettings.forEach((setting, index) => {
          formData.append(`paramsTelegram[${setting.xmlId}]`, setting.value ? "1" : "0");
        });
      }
    }

    if (emailSettings) {
      if (Array.isArray(emailSettings)) {
        emailSettings.forEach((setting, index) => {
          formData.append(`paramsEmail[${setting.xmlId}]`, setting.value ? "1" : "0");
        });
      }
    }

    if (pushSettings) {
      if (Array.isArray(pushSettings)) {
        pushSettings.forEach((setting, index) => {
          formData.append(`paramsPush[${setting.xmlId}]`, setting.value ? "1" : "0");
        });
      }
    }

    if(values.workLogo) formData.append("workLogo", values.workLogo)
    if(values.photo) formData.append("photo", values.photo)
    if(employeeId) formData.append("employeeId", employeeId)

    saveProfile(formData).then(
      data => {
        history.replace();
        dispatch(editUserData({ name: values.name, lastName: values.lastName }));
        standartInfoToast(data)
        setIsUpdationg(false)
      },
      standartErrorToast,
    ).finally(() => setIsUpdationg(false))
  };



  if (isProfileLoading ) return <Preloader loading={true} />

  const defaultValues = {
    id: data.id,
    name: data.name,
    lastName: data.lastName,
    description: data.description,
    patronymic: data.patronymic,
    phone: data.phone?.length ? data.phone : [""],
    email: data.email?.length ? data.email : [""],
    telegram: data.telegram,
    photo: data?.photo,
    watsApp: data.watsApp,
    ...(canEditAgency ? {
      workLogo: data?.workLogo,
      workCompany: data?.workCompany,
      cityName: data?.cityName,
    } : [])
  }
  return <>
    <PersonalCabinet/>
    <Form
    defaultValues={defaultValues}
    profile={data}
    canEditAgency={canEditAgency}
    edit={handleSave}
    editPassword={changePassword}
    history={history}
    settings={settings}
    setSettings={setSettings}
    showRequisites={isNotAgent && !isProfileLoading}
    setTgSettings={setTgSettings}
    tgSettings={tgSettings}
    setEmailSettings={setEmailSettings}
    emailSettings={emailSettings}
    setPushSettings={setPushSettings}
    pushSettings={pushSettings}
    isUpdating={isUpdating}
    isEmployee={!!employeeId}
  />
  </>
};

export default Profile
